import React from 'react';
import { useFormMultiplierContext } from '../../../../../../Services/FormMultiplierContext';

interface FormMultiplierRemoveButtonProps {
	children: React.ReactElement;
}

const FormMultiplierRemoveButton: React.FC<
	FormMultiplierRemoveButtonProps
> = props => {
	const { children } = props;
	const { onClick, isVisible } = useFormMultiplierContext();

	if (!isVisible) {
		return <></>;
	}

	return <div onClick={onClick}>{children}</div>;
};

export default FormMultiplierRemoveButton;
